import {setLoading} from "../common/Loader/slice";
import requestUtil from "../../helpers/requestUtil";
import * as Toasts from '../common/Toastify';
import {
    jobListingFailed,
    updateJobListings,
    setPage,
    setSorting,
    updatePageSize,
    updateMasterDatas,
    setFilterData,updateClearFilter,setError
} from "./slice";

const isEmpty = (str) => {
    return !str || ""===str.trim();
}
const createLoadRequest = (page, pageSize, empId, fromDate, toDate, location, searchText, sortOrder, sortColumn) => {
    const request = {
        "page": page,
        "pageSize": pageSize,
        "employerUniqueId": `${empId}`
    }
    if(!isEmpty(fromDate)){
        request.fromDateTime = fromDate;
    }
    if(!isEmpty(toDate)) {
        request.toDateTime = toDate;
    }
    if(location) {
        request.location = location?.id;
    }
    if(!isEmpty(searchText)){
        request.searchText = searchText;
    }
    if(sortColumn && sortColumn !== ""){
        request.sortOrder = sortOrder;
        request.sortColumn = sortColumn;
    }
    return request;
}

export function loadJobListings({url, empId, pageToLoad}) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true));
        try {
            const state = getState();
            const { page, pageSize, sortOrder, sortColumn, filterFields } = state.jobListing;
            const request = createLoadRequest(pageToLoad || page, pageSize, empId, filterFields.fromDate, filterFields.toDate, filterFields.location, filterFields.searchText, sortOrder, sortColumn);
            const jobListing = await requestUtil(`${url}/Jobs/getalljobs`, 'POST', request);
            dispatch(updateJobListings({
                data: jobListing,
                page: pageToLoad || page
            }));
            dispatch(setLoading(false));
        }catch(error){
            dispatch(jobListingFailed(error.message));
            dispatch(setLoading(false));
        }
    }
}
export function nextPage() {
    return async (dispatch, getState) => {
        const state = getState();
        const { page, pageSize, data } = state.jobListing;
        const lastPage = Math.ceil(data.totalCount/pageSize)
        dispatch(setPage({
            page: (page + 1) > lastPage ? lastPage : (page + 1)
        }));
    }
}
export function firstPage() {
    return async (dispatch) => {
        dispatch(setPage({
            page: 1
        }));
    }
}
export function gotoPage(pageNumber) {
    return async (dispatch) => {
        dispatch(setPage({
            page: pageNumber
        }));
    }
}
export function previousPage() {
    return async (dispatch, getState) => {
        const state = getState();
        const { page } = state.jobListing;
        dispatch(setPage({
            page: (page - 1) < 1 ? 1 : (page-1)
        }));
    }
}
export function lastPage() {
    return async (dispatch, getState) => {
        const state = getState();
        const { pageSize, data } = state.jobListing;
        const lastPage = Math.ceil(data.totalCount/pageSize)
        dispatch(setPage({
            page: lastPage
        }));
    }
}
export function setPageSize( size){
    return async (dispatch) => {
        dispatch(updatePageSize({
            pageSize: size
        }));
    }
}

export function updateSort( order, column) {
    return async (dispatch) => {
        dispatch(setSorting({
            sortOrder: order,
            sortColumn: column
        }));
    }
}

export function loadMasterDatas(url, employerId) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        try {
            const locationList = await requestUtil(`${url}/Locations/get-location-list-for-dropdown/${employerId}`, 'GET');
            dispatch(updateMasterDatas({locationList}));
            dispatch(setLoading(false));
        }catch (error) {
            dispatch(jobListingFailed(error.message));
            dispatch(setLoading(false));
        }
    }
}
export function updateFilterFields(fieldName, value) {
    return async (dispatch) => {
        dispatch(setFilterData({fieldName, value}));
    }
}
export function clearFilter() {
    return async (dispatch) => {
        dispatch(updateClearFilter());
    }
}

export const deleteJob = ({ url, params }) => { 
    return async (dispatch) => {
        dispatch(setLoading(true));
        try {
            console.log(url,params);
            const response = await requestUtil(`${url}`, 'POST', { ...params });
          //  const response = await requestUtil(`${url}/Jobs/delete-job-details/${jobUniqueId}`, 'POST');
          if (response.result === 1) {
            Toasts.success(response.message);
          } else if (response.result === 0) {
            Toasts.warning(response.message)
          }
            
        } catch (error) {
            dispatch(setError(error.message))
        }
      //  dispatch(setLoading(false));
    }
}